import CellListItem from './CellListItem';

export default CellListItem;